import React from "react";

function FreePlanAnimation() {
  return (
    <section className="zv-free-plan-page">
      <style>{`
        * {
          box-sizing: border-box;
        }

        .zv-free-plan-page {
          width: 100%;
          min-height: 100vh;
          overflow: hidden;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: clamp(18px, 3vw, 42px);
          font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          background:
            radial-gradient(circle at 15% 18%, rgba(34, 197, 94, 0.18) 0, transparent 28%),
            radial-gradient(circle at 86% 16%, rgba(14, 165, 233, 0.14) 0, transparent 30%),
            linear-gradient(135deg, #f0fdf4 0%, #f8fafc 46%, #eef2ff 100%);
          color: #0f172a;
        }

        .zv-bg-grid {
          position: absolute;
          inset: 0;
          opacity: 0.32;
          background-image:
            linear-gradient(rgba(15, 23, 42, 0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(15, 23, 42, 0.04) 1px, transparent 1px);
          background-size: 42px 42px;
          mask-image: radial-gradient(circle at center, black 0%, transparent 78%);
          pointer-events: none;
        }

        .zv-stage {
          position: relative;
          z-index: 2;
          width: min(100%, 1240px);
          min-height: min(860px, calc(100vh - 48px));
          display: grid;
          grid-template-columns: 1.05fr 0.95fr;
          gap: clamp(20px, 4vw, 56px);
          align-items: center;
        }

        .zv-copy {
          min-width: 0;
        }

        .zv-kicker {
          width: fit-content;
          display: flex;
          align-items: center;
          gap: 9px;
          padding: 9px 13px;
          margin-bottom: 18px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.72);
          border: 1px solid rgba(22, 163, 74, 0.16);
          box-shadow: 0 14px 35px rgba(15, 23, 42, 0.07);
          color: #166534;
          font-size: 13px;
          font-weight: 900;
          backdrop-filter: blur(14px);
        }

        .zv-kicker-dot {
          width: 9px;
          height: 9px;
          border-radius: 999px;
          background: #22c55e;
          box-shadow: 0 0 0 7px rgba(34, 197, 94, 0.14);
        }

        .zv-headline {
          margin: 0;
          max-width: 680px;
          font-size: clamp(42px, 6vw, 82px);
          line-height: 0.92;
          letter-spacing: -0.075em;
          color: #0f172a;
        }

        .zv-headline span {
          display: block;
          color: #16a34a;
        }

        .zv-description {
          max-width: 590px;
          margin: 22px 0 0;
          color: #475569;
          font-size: clamp(16px, 1.6vw, 20px);
          line-height: 1.7;
          font-weight: 650;
        }

        .zv-mini-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 14px;
          max-width: 650px;
          margin-top: 30px;
        }

        .zv-mini-card {
          min-height: 138px;
          padding: 18px;
          border-radius: 26px;
          background: rgba(255, 255, 255, 0.78);
          border: 1px solid rgba(15, 23, 42, 0.08);
          box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
          backdrop-filter: blur(16px);
        }

        .zv-mini-icon {
          width: 42px;
          height: 42px;
          display: grid;
          place-items: center;
          border-radius: 16px;
          margin-bottom: 14px;
          background: #dcfce7;
          color: #15803d;
          font-size: 20px;
          font-weight: 900;
        }

        .zv-mini-label {
          margin: 0;
          color: #0f172a;
          font-size: 15px;
          font-weight: 950;
          letter-spacing: -0.025em;
        }

        .zv-mini-text {
          margin: 7px 0 0;
          color: #64748b;
          font-size: 13px;
          line-height: 1.45;
          font-weight: 700;
        }

        .zv-visual {
          position: relative;
          display: grid;
          place-items: center;
          min-height: 690px;
        }

        .zv-phone-wrap {
          position: relative;
          width: min(390px, 86vw);
          aspect-ratio: 0.56;
        }

        .zv-phone-glow {
          position: absolute;
          inset: 9% -10% 7%;
          border-radius: 54px;
          background: radial-gradient(circle, rgba(34, 197, 94, 0.25), rgba(14, 165, 233, 0.08), transparent 68%);
          filter: blur(28px);
        }

        .zv-phone {
          position: absolute;
          inset: 0;
          border-radius: 54px;
          padding: 14px;
          background: linear-gradient(145deg, #0f172a, #020617);
          box-shadow:
            0 34px 90px rgba(15, 23, 42, 0.34),
            inset 0 0 0 1px rgba(255,255,255,0.08);
        }

        .zv-phone::before {
          content: "";
          position: absolute;
          left: 50%;
          top: 14px;
          width: 88px;
          height: 10px;
          border-radius: 999px;
          transform: translateX(-50%);
          background: #1e293b;
          z-index: 4;
        }

        .zv-screen {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 42px;
          background:
            radial-gradient(circle at 18% 10%, rgba(34,197,94,0.14), transparent 26%),
            linear-gradient(180deg, #f8fafc, #eef2f7);
        }

        .zv-chat-header {
          height: 92px;
          padding: 32px 20px 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          background: linear-gradient(135deg, #16a34a, #0f766e);
          color: white;
        }

        .zv-doc-avatar {
          width: 42px;
          height: 42px;
          border-radius: 16px;
          display: grid;
          place-items: center;
          background: rgba(255, 255, 255, 0.95);
          color: #16a34a;
          font-weight: 1000;
          box-shadow: 0 12px 24px rgba(15, 23, 42, 0.15);
        }

        .zv-doc-name {
          margin: 0;
          font-size: 14px;
          font-weight: 950;
        }

        .zv-doc-status {
          margin: 3px 0 0;
          font-size: 11px;
          font-weight: 800;
          color: #dcfce7;
        }

        .zv-screen-badge {
          margin-left: auto;
          padding: 7px 10px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.18);
          color: #ffffff;
          font-size: 10px;
          font-weight: 950;
        }

        .zv-chat-body {
          position: relative;
          height: calc(100% - 92px);
          padding: 22px 17px 84px;
        }

        .zv-bubble {
          position: relative;
          max-width: 78%;
          padding: 12px 14px;
          border-radius: 19px;
          margin-bottom: 13px;
          font-size: 13px;
          line-height: 1.35;
          font-weight: 800;
          box-shadow: 0 12px 24px rgba(15, 23, 42, 0.07);
          opacity: 0;
          transform: translateY(10px) scale(0.97);
          animation: zvBubbleFast 6s ease-in-out infinite;
        }

        .zv-bubble.patient {
          margin-left: auto;
          background: #dcfce7;
          color: #14532d;
          border-bottom-right-radius: 7px;
        }

        .zv-bubble.doctor {
          margin-right: auto;
          background: #ffffff;
          color: #334155;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-bottom-left-radius: 7px;
        }

        .zv-bubble.one {
          animation-delay: 0.15s;
        }

        .zv-bubble.two {
          animation-delay: 0.9s;
        }

        .zv-bubble.three {
          animation-delay: 1.65s;
        }

        .zv-bubble.four {
          animation-delay: 2.4s;
        }

        .zv-typing {
          display: flex;
          align-items: center;
          gap: 5px;
          width: fit-content;
        }

        .zv-typing i {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #64748b;
          animation: zvTyping 0.75s ease-in-out infinite;
        }

        .zv-typing i:nth-child(2) {
          animation-delay: 0.1s;
        }

        .zv-typing i:nth-child(3) {
          animation-delay: 0.2s;
        }

        .zv-input-bar {
          position: absolute;
          left: 15px;
          right: 15px;
          bottom: 18px;
          height: 54px;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 9px 10px 9px 16px;
          border-radius: 999px;
          background: rgba(255,255,255,0.94);
          border: 1px solid rgba(226,232,240,0.95);
          box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);
        }

        .zv-input-placeholder {
          flex: 1;
          color: #94a3b8;
          font-size: 13px;
          font-weight: 800;
          overflow: hidden;
          white-space: nowrap;
        }

        .zv-input-placeholder span {
          display: inline-block;
          width: 0;
          overflow: hidden;
          border-right: 2px solid #16a34a;
          animation: zvTypeText 6s steps(27) infinite;
        }

        .zv-send {
          width: 37px;
          height: 37px;
          border-radius: 999px;
          display: grid;
          place-items: center;
          background: #16a34a;
          color: white;
          font-weight: 1000;
          animation: zvSendPulse 1.2s ease-in-out infinite;
        }

        .zv-floating-card {
          position: absolute;
          z-index: 5;
          width: 220px;
          padding: 16px;
          border-radius: 26px;
          background: rgba(255, 255, 255, 0.86);
          border: 1px solid rgba(15, 23, 42, 0.08);
          box-shadow: 0 24px 60px rgba(15, 23, 42, 0.13);
          backdrop-filter: blur(18px);
        }

        .zv-credit-card {
          top: 72px;
          left: -98px;
        }

        .zv-lock-card {
          right: -106px;
          top: 235px;
        }

        .zv-upgrade-card {
          right: -74px;
          bottom: 72px;
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.95), rgba(2, 6, 23, 0.96));
          color: white;
          opacity: 0;
          transform: translateY(12px) scale(0.96);
          animation: zvUpgradeFast 6s ease-in-out infinite;
          animation-delay: 3.2s;
        }

        .zv-card-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          margin-bottom: 12px;
        }

        .zv-card-title {
          margin: 0;
          font-size: 14px;
          font-weight: 1000;
          letter-spacing: -0.025em;
        }

        .zv-card-icon {
          width: 34px;
          height: 34px;
          border-radius: 14px;
          display: grid;
          place-items: center;
          background: #dcfce7;
          color: #15803d;
          font-weight: 1000;
        }

        .zv-credit-dots {
          display: flex;
          gap: 8px;
          margin-top: 12px;
        }

        .zv-credit-dots span {
          width: 25px;
          height: 25px;
          border-radius: 999px;
          display: grid;
          place-items: center;
          background: #16a34a;
          color: white;
          font-size: 11px;
          font-weight: 1000;
          animation: zvCreditUseFast 6s ease-in-out infinite;
        }

        .zv-credit-dots span:nth-child(1) { animation-delay: 0.4s; }
        .zv-credit-dots span:nth-child(2) { animation-delay: 1s; }
        .zv-credit-dots span:nth-child(3) { animation-delay: 1.6s; }
        .zv-credit-dots span:nth-child(4) { animation-delay: 2.2s; }
        .zv-credit-dots span:nth-child(5) { animation-delay: 2.8s; }

        .zv-card-text {
          margin: 0;
          color: #64748b;
          font-size: 13px;
          line-height: 1.5;
          font-weight: 750;
        }

        .zv-upgrade-card .zv-card-text {
          color: #cbd5e1;
        }

        .zv-lock-list {
          display: grid;
          gap: 8px;
          margin-top: 11px;
        }

        .zv-lock-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #9a3412;
          font-size: 13px;
          font-weight: 900;
        }

        .zv-lock-dot {
          width: 22px;
          height: 22px;
          border-radius: 9px;
          display: grid;
          place-items: center;
          background: #ffedd5;
          color: #ea580c;
          font-size: 12px;
        }

        .zv-lock-card {
          animation: zvMediaAttention 6s ease-in-out infinite;
          animation-delay: 3s;
        }

        .zv-cta-row {
          display: flex;
          gap: 8px;
          margin-top: 14px;
        }

        .zv-price-pill {
          flex: 1;
          padding: 9px 8px;
          border-radius: 14px;
          background: rgba(34, 197, 94, 0.16);
          color: #bbf7d0;
          text-align: center;
          font-size: 12px;
          font-weight: 1000;
          border: 1px solid rgba(187, 247, 208, 0.16);
        }

        @keyframes zvBubbleFast {
          0%, 4% {
            opacity: 0;
            transform: translateY(10px) scale(0.97);
          }
          9%, 72% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          88%, 100% {
            opacity: 0;
            transform: translateY(-5px) scale(0.99);
          }
        }

        @keyframes zvTyping {
          0%, 100% {
            opacity: 0.25;
            transform: translateY(0);
          }
          50% {
            opacity: 1;
            transform: translateY(-4px);
          }
        }

        @keyframes zvTypeText {
          0%, 18% {
            width: 0;
          }
          40%, 72% {
            width: 185px;
          }
          84%, 100% {
            width: 0;
          }
        }

        @keyframes zvSendPulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(22, 163, 74, 0.24);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.08);
          }
        }

        @keyframes zvCreditUseFast {
          0%, 10% {
            opacity: 1;
            transform: scale(1);
            background: #16a34a;
          }
          20%, 100% {
            opacity: 0.28;
            transform: scale(0.88);
            background: #94a3b8;
          }
        }

        @keyframes zvMediaAttention {
          0%, 48%, 100% {
            transform: translateX(0);
          }
          54% {
            transform: translateX(-7px);
          }
          60% {
            transform: translateX(7px);
          }
          66% {
            transform: translateX(-4px);
          }
          72% {
            transform: translateX(0);
          }
        }

        @keyframes zvUpgradeFast {
          0%, 50% {
            opacity: 0;
            transform: translateY(12px) scale(0.96);
          }
          58%, 86% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateY(8px) scale(0.98);
          }
        }

        @media (max-width: 980px) {
          .zv-free-plan-page {
            align-items: flex-start;
            overflow-y: auto;
          }

          .zv-stage {
            min-height: auto;
            grid-template-columns: 1fr;
            gap: 36px;
            padding: 24px 0;
          }

          .zv-copy {
            text-align: center;
          }

          .zv-kicker {
            margin-left: auto;
            margin-right: auto;
          }

          .zv-description {
            margin-left: auto;
            margin-right: auto;
          }

          .zv-mini-grid {
            margin-left: auto;
            margin-right: auto;
          }

          .zv-visual {
            min-height: 640px;
          }

          .zv-credit-card {
            left: 0;
          }

          .zv-lock-card {
            right: 0;
          }

          .zv-upgrade-card {
            right: 18px;
          }
        }

        @media (max-width: 640px) {
          .zv-free-plan-page {
            padding: 18px 14px;
          }

          .zv-stage {
            gap: 20px;
          }

          .zv-headline {
            font-size: clamp(38px, 12vw, 58px);
          }

          .zv-description {
            font-size: 15px;
          }

          .zv-mini-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }

          .zv-mini-card {
            min-height: auto;
            display: flex;
            align-items: center;
            gap: 14px;
            text-align: left;
            padding: 14px;
            border-radius: 20px;
          }

          .zv-mini-icon {
            margin: 0;
            flex: 0 0 auto;
          }

          .zv-visual {
            min-height: 625px;
            transform: scale(0.92);
            transform-origin: top center;
          }

          .zv-phone-wrap {
            width: min(330px, 92vw);
          }

          .zv-floating-card {
            width: 178px;
            padding: 13px;
            border-radius: 20px;
          }

          .zv-card-title {
            font-size: 12px;
          }

          .zv-card-text {
            font-size: 11.5px;
          }

          .zv-credit-card {
            top: 32px;
            left: -8px;
          }

          .zv-lock-card {
            right: -8px;
            top: 250px;
          }

          .zv-upgrade-card {
            right: 8px;
            bottom: 38px;
          }

          @keyframes zvTypeText {
            0%, 18% {
              width: 0;
            }
            40%, 72% {
              width: 150px;
            }
            84%, 100% {
              width: 0;
            }
          }
        }
      `}</style>

      <div className="zv-bg-grid" />

      <div className="zv-stage">
        <div className="zv-copy">
          <div className="zv-kicker">
            <span className="zv-kicker-dot" />
            Zaviramed Free Plan Demo
          </div>

          <h1 className="zv-headline">
            Start with care.
            <span>Upgrade when ready.</span>
          </h1>

          <p className="zv-description">
            The Free Plan lets patients speak to a doctor through WhatsApp using
            text. They get 5 free messages every 24 hours. Images, voice notes,
            videos and faster response are unlocked with paid access.
          </p>

          <div className="zv-mini-grid">
            <div className="zv-mini-card">
              <div className="zv-mini-icon">5</div>
              <div>
                <p className="zv-mini-label">5 free texts</p>
                <p className="zv-mini-text">
                  Patients can send up to 5 text messages every 24 hours.
                </p>
              </div>
            </div>

            <div className="zv-mini-card">
              <div className="zv-mini-icon">Aa</div>
              <div>
                <p className="zv-mini-label">Text only</p>
                <p className="zv-mini-text">
                  Free users cannot send images, videos or voice notes.
                </p>
              </div>
            </div>

            <div className="zv-mini-card">
              <div className="zv-mini-icon">₦</div>
              <div>
                <p className="zv-mini-label">Paid access</p>
                <p className="zv-mini-text">
                  ₦1,500 gives 24 hours. ₦10,000 gives 30 days.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="zv-visual">
          <div className="zv-phone-wrap">
            <div className="zv-phone-glow" />

            <div className="zv-floating-card zv-credit-card">
              <div className="zv-card-top">
                <p className="zv-card-title">Free text credits</p>
                <div className="zv-card-icon">✓</div>
              </div>
              <p className="zv-card-text">
                5 messages are available every 24 hours.
              </p>
              <div className="zv-credit-dots">
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
              </div>
            </div>

            <div className="zv-floating-card zv-lock-card">
              <div className="zv-card-top">
                <p className="zv-card-title">Media locked</p>
                <div className="zv-card-icon">🔒</div>
              </div>
              <p className="zv-card-text">Free Plan supports text only.</p>
              <div className="zv-lock-list">
                <div className="zv-lock-item">
                  <span className="zv-lock-dot">×</span> Images
                </div>
                <div className="zv-lock-item">
                  <span className="zv-lock-dot">×</span> Voice notes
                </div>
                <div className="zv-lock-item">
                  <span className="zv-lock-dot">×</span> Videos
                </div>
              </div>
            </div>

            <div className="zv-floating-card zv-upgrade-card">
              <div className="zv-card-top">
                <p className="zv-card-title">Need full access?</p>
                <div className="zv-card-icon">★</div>
              </div>
              <p className="zv-card-text">
                Upgrade for media support and faster doctor response.
              </p>
              <div className="zv-cta-row">
                <div className="zv-price-pill">₦1,500 / 24hr</div>
                <div className="zv-price-pill">₦10k / 30d</div>
              </div>
            </div>

            <div className="zv-phone">
              <div className="zv-screen">
                <div className="zv-chat-header">
                  <div className="zv-doc-avatar">Z</div>
                  <div>
                    <p className="zv-doc-name">Zaviramed Doctor</p>
                    <p className="zv-doc-status">Free plan support</p>
                  </div>
                  <div className="zv-screen-badge">TEXT ONLY</div>
                </div>

                <div className="zv-chat-body">
                  <div className="zv-bubble patient one">
                    Hello doctor, I have headache.
                  </div>

                  <div className="zv-bubble doctor two">
                    How long has it been happening?
                  </div>

                  <div className="zv-bubble patient three">
                    Since yesterday evening.
                  </div>

                  <div className="zv-bubble doctor four">
                    <div className="zv-typing">
                      <i />
                      <i />
                      <i />
                    </div>
                  </div>

                  <div className="zv-input-bar">
                    <div className="zv-input-placeholder">
                      <span>Type your message...</span>
                    </div>
                    <div className="zv-send">›</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FreePlanAnimation;